<template>
  <Modal :id="'cpm-add-contact-modal'" @cancelled="onCancel">
    <template slot="header">
      <template v-if="isEdit">
        {{$t('edit_gema')}}
      </template>
      <template v-else>
        {{$t('new_gema')}}
      </template>
    </template>

    <template slot="body">
      <div class="fform-group">
        <TextField
          class="m1"
          :id="'set_no'"
          v-model="product_media.set_no"
          :placeholder="$t('set_no')"
          isModel
          required
          v-bind="requiredTCon"
          @validated="onValidation"
        />
        <Dropdown
          :options="mediasTV"
          class="group-input m2"
          :placeholder="$t('media_type')"
          v-on:selectedChange="(e) => onMediaTypeChange(e)"
          :selected="mediasTV.find(e=>e.value == product_media.media_id)"
          box
          :listHeight="250"
        />
        <TextField
          class="m1"
          :id="'mechanical_reg_no'"
          v-bind="textFieldConfig"
          :value="product_media.mechanical_reg_no"
          :placeholder="$t('registration_no')"
          @valuechanged="onTextFieldValueChange"
        />        
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <button
        class="dt-button v1 with-ico"
     
        @click.stop="addNewProduct"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/dt-plugins/modal/modal";
import { createTV } from "../../../../models/text-value.model";
import { ProductsService } from '../../services/products.service';
import { createFormItemMixin, createFormModalMixin } from '../../../../dt-plugins/form-modal/form-modal';
import { createTextFieldConfig } from '../../../../plugins/text-field';

export default {
  components: {
    Modal  
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },

      requiredTCon: createTextFieldConfig({       
        height: 42,
        showEditIconOnHover: false,
        box: true,
        required:true,
        immediateValidation: true,
        showValidationIcons: true,
      }),
    
      validationResult: {},
      selectedProductMedia: this.resetProductMedia(),     
    };
  },
  mounted:async function () {
    // if(this.$route.query.product_media_id) {
    //   const respData = await ProductsService.editProductMedia(this.external_id, this.$route.query.product_media_id);
  
    //   this.selectedProductMedia = respData.data.product_media || this.resetProductMedia();
    //   this.mediaTypeId = this.selectedProductMedia.product_media_id;
    //   this.medias = respData.data.medias;

    // } else {
    //   const resData=await ProductsService.addProductMedia(this.external_id);
    //   this.medias= resData.data.medias;
    // }
  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: 'product_media_id',
      itemKey: 'product_media',
      detailsHttpReq: ProductsService.editProductMedia,
      addHttpReq:ProductsService.addProductMedia
      
    })
  ],
  computed: {
    isEdit: function(){
      return this.$route.query.product_media_id? true: false;
    },
    external_id: function() {
      return this.$route.query.external_id;
    },
    mediasTV:function(){
      console.log("this.details?.medias",this.details);
      return createTV(this.details?.medias, 'media_name', 'media_id');
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    } 
  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
    },    
    onTextFieldValueChange: function (name, value) {    
      this.product_media[name]=value;
    },

    resetProductMedia: function() {
      return {
        set_no: '',
        mechanical_reg_no: '',
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    addNewProduct: function (e) {
      console.log("product_media",this.product_media);
      if(this.isEdit) {
        // const payload= { 
        //   mechanical_reg_no:this.product_media.mechanical_reg_no,
        //   product_media_id:this.product_media.media_id,
        //   set_no:this.product_media.set_no
        // };
      
         this.$emit("edited",{
                              ...this.product_media, 
                              kVal: this.product_media.product_media_id,
                              media_name:this.mediasTV.find(e=>e.value==this.product_media.media_id).text
                              }
                    );
      }
      else{
        // const payload={ mechanical_reg_no:this.product_media.mechanical_reg_no,
        //               product_media_id:this.product_media.media_id,
        //               set_no:this.product_media.set_no,
        //               kVal:this.$route.query.product_media_id
        //             };
        this.$emit("added",this.product_media);
      }
      

    },
    onMediaTypeChange: function (value) {
      this.product_media.media_id=value.value;
    },

    get_product_media: function() {
      return {
        product_media_id:'',
        set_no: '',
        mechanical_reg_no: '',
        media_id:'',
      }
    }

    //MARK: Methods
  },
};


</script>

<style lang="scss">
.cpm-add-contact-modal {
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }

    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .person-controls,
  .company-controls {
    height: 249px;
  }

  .contact-type-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;
    .contact-type {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
